import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { routePaths } from "../../../routes/route-paths";

/**
 * The hypothetical-performance note, set as a footnote under anything that shows backtested
 * figures. It goes at the foot rather than beside the figures: five sentences under a page title or
 * between the figures and the price crowded both on a phone.
 */
export function BacktestNote({
  text,
  className = "mt-4",
}: {
  /** Defaults to the general note; the strategy page passes the one naming its backtest window. */
  text?: string;
  className?: string;
}) {
  const { t } = useTranslation("tradingStrategies");

  return (
    <p
      className={`text-body-secondary border-top pt-3 mb-0 ${className}`}
      style={{ fontSize: "0.75rem", lineHeight: 1.6 }}
    >
      {text ?? t("performanceNote")}{" "}
      <Link to={`${routePaths.disclosures}#hypothetical`}>
        {t("performanceNoteLink")}
      </Link>
    </p>
  );
}
